module.exports = __webpack_public_path__ + "static/media/cred_mod_D_secc.d5325f71.png";